import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
    selector: 'app-branch-license-confirm',
    templateUrl: './branch-license-confirm.component.html',
    styleUrls: ['./branch-license-confirm.component.css']
})
export class BranchLicenseConfirmComponent implements OnInit {
    title: string;
    confirmationMessage: string;
    type: any;
    corporateId: any;
    api_error: any;
    api_success: any;
    disableConfirmbtn = false;
    constructor(
        private matDialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private corporateService: CorporateService
    ) {
    }
    ngOnInit() {
        this.title = this.data['title'];
        this.type = this.data['type'];
        this.corporateId = this.data['corpId'];
        this.confirmationMessage = this.title;


    }
    onConfirm() {
        switch (this.type) {
            case 'updateBranchLicense': {
                this.disableConfirmbtn = true;
                this.corporateService.updateBranchLicense(this.corporateId)
                    .subscribe(res => {
                        this.disableConfirmbtn = false;
                        this.api_success = 'License of branch updated successfully';
                        setTimeout(() => {
                            this.matDialogRef.close();
                        }, 2000);

                    },
                        (error) => {
                            this.disableConfirmbtn = false;
                            this.api_error = error.error;
                        });
                break;
            }
            case 'updateBranchAddon': {
                this.disableConfirmbtn = true;
                this.corporateService.updateBranchAddon(this.corporateId)
                    .subscribe(res => {
                        this.disableConfirmbtn = false;
                        this.api_success = 'Addons of branch updated successfully';
                        setTimeout(() => {
                            this.matDialogRef.close();
                        }, 2000);
                    },
                        (error) => {
                            this.disableConfirmbtn = false;
                            this.api_error = error.error;
                        });
                break;
            }
            case 'renewBranchLicense': {
                this.disableConfirmbtn = true;
                this.corporateService.renewBranchLicense(this.corporateId)
                    .subscribe(res => {
                        this.disableConfirmbtn = false;
                        this.api_success = 'Branch License renewed successfully';
                        setTimeout(() => {
                            this.matDialogRef.close();
                        }, 2000);

                    },
                        (error) => {
                            this.disableConfirmbtn = false;
                            this.api_error = error.error;
                        });
                break;
            }
        }
    }
}
